import { useEffect, useState } from 'react';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import { API_MEMBERSHIP_PRICE_DEFAULT } from '../../../Domain/Redux/Paths';

const useMembershipPriceDefault = (scheduler, modeId) => {
  const [membershiPriceDefault, setMembershiPriceDefault] = useState({});

  useEffect(() => {
    if ((scheduler?.id || scheduler) && modeId) {
      fetchMembershipPriceFixed(scheduler);
    }
  }, [scheduler, modeId]);

  const fetchMembershipPriceFixed = async (scheduler) => {
    const dataPayload = {
      mode_id: modeId,
      scheduler_id: scheduler?.id ?? scheduler
    };

    try {
      const membershiPriceDefault = await HttpClient.GET(API_MEMBERSHIP_PRICE_DEFAULT, dataPayload);
      setMembershiPriceDefault(membershiPriceDefault?.content?.[0]);
    } catch (error) {
      console.error(error);
    }
  };

  return { membershiPriceDefault };
};

export default useMembershipPriceDefault;
